'use client';

import { CopyIcon } from "@components/icons";
import { CustomTooltip } from "@components/utilities";
import { useState } from "react";
import { SecondaryButton } from "..";

export function CopyButton({ children, className, iconClassName = "size-4 stroke-2", iconColor = "currentcolor", contentToCopy = "", ...props }) {
    const [tooltipContent, setTooltipContent] = useState("Copier le lien");

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(contentToCopy)
            setTooltipContent("Lien copié !");
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <CustomTooltip content={tooltipContent} placement="top" offset={20}>
            <SecondaryButton className={`h-fit min-h-0 min-w-0 rounded-full !p-1 ${className}`} onClick={handleCopyLink}>
                <CopyIcon className={iconClassName} color={iconColor} />
            </SecondaryButton>
        </CustomTooltip>
    )
}

